import { useAuthStore } from '../store/shared/auth-store';

export const featureFlag = Object.freeze({
	E_COMMERCE: 'E_COMMERCE',
	LINKER_AGENT: 'LINKER_AGENT',
	EDUCATION: 'EDUCATION',
	ECOMMERCE_AI: 'ECOMMERCE_AI',
	REAL_ESTATE: 'REAL_ESTATE',
	CAR_CARE: 'CAR_CARE',
	AI_AGENT: 'AI_AGENT',
	HDTC: 'HDTC',
	VERIFY_SY: 'VERIFY_SY',
   CUSTOMER_SERVICE: 'CUSTOMER_SERVICE',
   SADIDLEE: 'SADIDLEE',
   KNOWLEDGE_BASE_V2: 'KNOWLEDGE_BASE_V2',
});

const checkFeatureFlag = (feature) => {
	const authStore = useAuthStore();
	const flags = authStore.featureFlags || [];

	if (Array.isArray(feature)) {
		return feature.some((f) => {
			const flag = flags.find((item) => item.feature_name === f);
			return !!flag?.is_enabled;
		});
	} else {
		const flag = flags.find((item) => item.feature_name === feature);
		return !!flag?.is_enabled;
	}
};

export const isFeatureFlagEnabled = (feature) => {
	return FeatureFlagOperator.eval(feature);
};

export const Operator = {
	NOT: 'not',
	AND: 'and',
	OR: 'or',
};

export class FeatureFlagOperator {
	constructor(data) {
		this.type = data.type;
		this.feature = data.feature;
	}

	static not(feature) {
		return {
			type: Operator.NOT,
			feature,
			handler: (feature) => {
				return !checkFeatureFlag(feature);
			},
		};
	}

   static and(feature) {
      return {
         type: Operator.AND,
         feature,
         handler: (feature) => {
            if (Array.isArray(feature)) {
               return feature.every((f) => FeatureFlagOperator.eval(f));
            } else {
               return FeatureFlagOperator.eval(feature);
            }
         },
      };
   }

   static or(feature) {
      return {
         type: Operator.OR,
         feature,
         handler: (feature) => {
            if (Array.isArray(feature)) {
               return feature.some((f) => FeatureFlagOperator.eval(f));
            } else {
               return FeatureFlagOperator.eval(feature);
            }
         },
      };
   }

	static eval(operator) {
		if (typeof operator === 'string' || Array.isArray(operator)) {
			return checkFeatureFlag(operator);
		} else if (typeof operator === 'object') {
			return operator?.handler(operator.feature);
		} else {
			return checkFeatureFlag(operator);
		}
	}
}
